import SubmitButton from "@/modals/login/submitButton";
import DatePicker from "@/wmCompoments/datePicker";
import Input from "@/wmCompoments/input";
import classNames from "classnames";
import React, { useMemo, useState } from "react";
import styles from './baseInfo.module.scss'
import { useUserInfo } from "@/api/request";
import { useBindUserInfo } from "./api";
import Toast from "@/wmCompoments/toast";
import { useTranslation } from "react-i18next";

function formatDateToYMD(input) {
    const date = new Date(input);
    if (isNaN(date.getTime())) return ''; // 无效日期

    const yyyy = date.getFullYear();
    const mm = String(date.getMonth() + 1).padStart(2, '0');
    const dd = String(date.getDate()).padStart(2, '0');

    return `${yyyy}-${mm}-${dd}`;
}

const BaseInfo = () => {
    const { t } = useTranslation('personalInfo')

    const [date, setDate] = useState<Date | null>(null);

    const { data, mutate } = useUserInfo()

    const { trigger: triggerUser, isMutating: mutatingUser } = useBindUserInfo()

    const [valueRealName, setValueRealName] = useState('')
    /**1男 2女 */
    const [valueSex, setValueSex] = useState('1')

    const hasRealName = !!data?.realName
    const hasSex = !!data?.sex
    const hasDate = !!data?.birthday


    const btnShow = useMemo(() => {
        const hasRealName = !!data?.realName
        const hasSex = !!data?.sex
        const hasDate = !!data?.birthday
        return !hasRealName || !hasSex || !hasDate
    }, [data])

    const btnDisibled = useMemo(() => {
        const hasRealName = !!data?.realName
        const hasDate = !!data?.birthday
        const disabledName = !hasRealName && !valueRealName
        const disabledDate = !hasDate && !date
        return disabledName || disabledDate
    }, [data, valueRealName, date])

    const onClickSubmit = async () => {
        const hasRealName = !!data?.realName
        const hasSex = !!data?.sex
        const hasDate = !!data?.birthday
        const params: any = {
            realName: undefined,
            sex: undefined,
            birthday: undefined
        }
        !hasRealName && (params.realName = valueRealName)
        !hasSex && (params.sex = valueSex)
        !hasDate && (params.birthday = formatDateToYMD(date))
        try {
            await triggerUser({
                ...params
            })
            await mutate()
        } catch (error: any) {
            Toast.show(error?.message || JSON.stringify(error))
        }
    }



    return (
        <div className={styles.warpper}>
            <div className={styles.title}>{t('basicInfo')}</div>
            <div className={styles.warpperDate}>
                <span>{t('registerDate')}</span>
                <span>{data?.createdAt}</span>
            </div>

            <div className={classNames(styles.warpperName)}>
                <span >{t('realName')}</span>
                {
                    hasRealName ? <div>
                        <span>{data?.realName}</span>
                    </div> : <Input onChange={(v) => {
                        setValueRealName(v)
                    }} hidePlaceholder={true} value={valueRealName} placeholder={t('enterRealName')} className={styles.inputName} />
                }
            </div>
            <div className={styles.gender}>
                <span>{t('gender')}</span>
                {
                    hasSex ? <div>{data?.sex == '1' ? t('male') : t('female')}</div> : <>
                        <div className={classNames(styles.genderBox, {
                            [styles.selectSex]: valueSex === '1'
                        })} onClick={() => {
                            setValueSex('1')
                        }}>
                            <div />
                            <span>{t('male')}</span>
                        </div>
                        <div className={classNames(styles.genderBox, {
                            [styles.selectSex]: valueSex === '2'
                        })} onClick={() => {
                            setValueSex('2')
                        }}>
                            <div />
                            <span>{t('female')}</span>
                        </div>
                    </>
                }

            </div>
            <div className={classNames(styles.warpperBirthday)}>
                <span>{t('birthDate')}</span>
                {
                    hasDate ? <div>{data?.birthday}</div> : <DatePicker maxDate={new Date()} value={date} mode={'single'} className={styles.datePicker} onChange={(v: any) => {
                        setDate(v)
                    }} />
                }
            </div>

            {btnShow && <div className={styles.submitBtutton}>
                <SubmitButton onClick={() => { onClickSubmit() }} text={t('complete')} type={'button'} disabled={btnDisibled} loading={mutatingUser} />
            </div>}

        </div>
    )
}

export default BaseInfo